import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { AddRule } from '../../api/rules-endpoint';
import SnackbarAlert from '../../components/Alerts';
import CancelButton from '../../components/CancelButton';
import RuleDetails from '../../components/rules/RuleDetails';
import useConfigStyles from '../../components/useConfigStyles';
import SubmitButton from '../../components/SubmitButton';
import { getLinkToRule } from '../../navigator/links';
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRulesContext } from '../../stores/rules-context';
import { Rule } from '../../types/rule';
import { defaultRule } from '../../types/defaultValues';

function RuleEditPage(): JSX.Element {
  const [rule, setRule] = useState<Rule>(defaultRule);
  const [responseMessage, setResponseMessage] = useState('');
  const [notify, toggleNotification] = useState(false);
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const classes = useConfigStyles();
  const navigate = useNavigate();
  const rulesContext = useRulesContext();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const response = await AddRule(rule);
    if (response.success) {
      setResponseMessage('Success');
      rulesContext.fetchData();
      navigate(getLinkToRule(rule.Name));
    } else {
      setResponseMessage(response.message || '');
      setErrors(response.errors || {});
    }
    toggleNotification(true);
  };

  const handleCloseSnackbar = () => {
    toggleNotification(false);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  const cleanErrors = (name: string) => {
    if (errors[name]) {
      delete errors[name];
    }
  };

  const handleRuleUpdate = (updatedRule: Rule, fieldName: string) => {
    setRule(updatedRule);
    cleanErrors(fieldName);
  };

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <Card>
        <CardContent>
          <RuleDetails rule={rule} editable errors={errors} onRuleUpdate={handleRuleUpdate} />
        </CardContent>
        <CardActions style={{'marginBottom': '24px'}}>
          <Grid container alignItems='center' justifyContent='center' direction='row' spacing={5}>
            <Grid item>
              <CancelButton label='Back' className={classes.button} onClick={handleCancelClick} />
            </Grid>
            <Grid item>
              <SubmitButton className={classes.button} label='Create Rule' />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <SnackbarAlert open={notify} message={responseMessage} handleClose={handleCloseSnackbar} />
    </form>
  );
}

export default RuleEditPage;
